// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snex-disclosures ul{list-style:none;padding-left:0;margin:0}.snex-disclosures ul>li{margin-bottom:8px}footer{color:var(--grayText)}", ""]);
// Exports
module.exports = exports;
